import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Context } from '../../context/Products';
import SkullSabres from '../../assets/img/skull_sabres.svg';
import './style.css';

export const COOKIE_CONSENT_KEY = 'captainCandyCookieConsent';
export const COOKIE_CONSENT_EVENT = 'captain-candy-cookie-consent';

const copy = {
    ka: {
        title: 'ქუქი-ფაილები',
        description: 'ვებსაიტის გამართულად მუშაობისთვის ვიყენებთ აუცილებელ ქუქი-ფაილებს. შენი თანხმობით ჩაიტვირთება გარე სერვისებიც, მათ შორის Google Maps.',
        policy: 'კონფიდენციალურობის პოლიტიკა',
        necessary: 'მხოლოდ აუცილებელი',
        accept: 'ყველას მიღება',
    },
    en: {
        title: 'Cookies',
        description: 'We use essential cookies to keep this website working. With your consent, external services such as Google Maps will also be loaded.',
        policy: 'Privacy policy',
        necessary: 'Necessary only',
        accept: 'Accept all',
    },
};

const CookieConsent = () => {
    const [{ lang }] = useContext(Context);
    const [visible, setVisible] = useState(false);
    const text = copy[lang] || copy.en;

    useEffect(() => {
        setVisible(!localStorage.getItem(COOKIE_CONSENT_KEY));
    }, []);

    const saveConsent = (value) => {
        localStorage.setItem(COOKIE_CONSENT_KEY, value);
        window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: value }));
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <aside className="cookie-consent" role="dialog" aria-modal="true" aria-labelledby="cookie-consent-title">
            <div className="cookie-consent__inner">
                <div className="cookie-consent__mark" aria-hidden="true">
                    <img src={SkullSabres} alt="" />
                </div>
                <div className="cookie-consent__content">
                    <h2 id="cookie-consent-title">{text.title}</h2>
                    <p>{text.description}</p>
                    <Link to="/personal-data-processing">{text.policy}</Link>
                </div>
                <div className="cookie-consent__actions">
                    <button type="button" className="cookie-consent__button cookie-consent__button--secondary" onClick={() => saveConsent('necessary')}>
                        {text.necessary}
                    </button>
                    <button type="button" className="cookie-consent__button cookie-consent__button--primary" onClick={() => saveConsent('all')}>
                        {text.accept}
                    </button>
                </div>
            </div>
        </aside>
    );
};

export default CookieConsent;
